import { Role } from "models/abac";

const roleOptions = Object.values(Role);

export { roleOptions };
